import { render, staticRenderFns } from "./BasicDatepicker.vue?vue&type=template&id=0a858d93"
import script from "./BasicDatepicker.vue?vue&type=script&lang=js"
export * from "./BasicDatepicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports